import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ContentView from './pages/ContentView';
import NotFound from './pages/NotFound';

const App = () => {
    const [currentPage, setCurrentPage] = useState('home');
    const [contentCode, setContentCode] = useState(null);
    const [language, setLanguage] = useState('zh'); // 'zh' 或 'en'
    const [loading, setLoading] = useState(false);

    // 检查URL参数，确定当前页面
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        
        if (code) {
            setCurrentPage('content');
            setContentCode(code);
        } else {
            setCurrentPage('home');
        }
        
        // 检查本地存储的语言设置
        const savedLanguage = localStorage.getItem('preferred_language');
        if (savedLanguage) {
            setLanguage(savedLanguage);
        }
    }, []);

    // 切换语言
    const toggleLanguage = () => {
        const newLanguage = language === 'zh' ? 'en' : 'zh';
        setLanguage(newLanguage);
        localStorage.setItem('preferred_language', newLanguage);
    };

    // 渲染当前页面
    const renderPage = () => {
        switch (currentPage) {
            case 'home':
                return <Home language={language} onViewContent={(code) => {
                    setContentCode(code);
                    setCurrentPage('content');
                    // 更新URL，但不刷新页面
                    window.history.pushState({}, '', `?code=${code}`);
                }} />;
            case 'content':
                return <ContentView 
                    contentCode={contentCode} 
                    language={language}
                    onBack={() => {
                        setCurrentPage('home');
                        window.history.pushState({}, '', '/');
                    }}
                />;
            default:
                return <NotFound language={language} />;
        }
    };

    return (
        <div className="app">
            <Header 
                language={language} 
                onToggleLanguage={toggleLanguage}
                currentPage={currentPage}
            />
            
            <main className="container py-4">
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">加载中...</span>
                        </div>
                    </div>
                ) : (
                    renderPage()
                )}
            </main>
            
            <Footer language={language} />
        </div>
    );
};

export default App; 